// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__tKPXf","wrapper":"styles_wrapper__0F0X_","container":"styles_container__t5UO_","answer":"styles_answer__ttfi0"};